import { FC } from 'react'
import type { TableTitleProps } from './types'
import { Typography } from '../../../Typography'
import { Button } from '../../../Button'

export const TableTitle: FC<TableTitleProps> = ({
  title,
  subtitle,
  buttons,
}) => (
  <div className="flex w-full py-2.5 px-4 h-20 items-center">
    <div className="grow">
      <Typography size="xl" weight="semibold" className="text-default">
        {title}
      </Typography>
      {subtitle && (
        <Typography size="sm" weight="regular" className="text-subtle">
          {subtitle}
        </Typography>
      )}
    </div>
    <div className="flex gap-x-4 items-center">
      {buttons?.map((buttonProps) => (
        <Button key={`button-${title}-${buttonProps.label}`} {...buttonProps} />
      ))}
    </div>
  </div>
)
